export default (methodPayment) => {
    if (!methodPayment) return 'método inválido';
    const methods = {
        credito: 'Cartão de Crédito',
        credit_card: 'Cartão de Crédito',
        pix: 'PIX',
        carne: 'Carnê',
    };

    return methods[methodPayment.toLowerCase()] ?? 'Não definido';
}